import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { CustomizedHttpService } from '../base/customized-http.service';
import { ContractType } from '../../models';
import { LocalDataCacheService } from '..';


@Injectable({
  providedIn: 'root'
})
export class SwProcessService {

  constructor(private httpService: CustomizedHttpService, private localDataStorage: LocalDataCacheService) { }

  getCjResponseSw(): Observable<ContractType> {
    return this.httpService.getByQuery<ContractType>('SwProcess/GetCjResponseSw', new HttpParams());
  }

  //getPageLabelSw(): Observable<PageLabelSwModel> {
  //  return this.httpService.get<PageLabelSwModel>("swprocess/pageLabelSw", new HttpParams());
  //}

  postCjResponseSw(model: ContractType): Observable<null> {
    let request = {
      contractType: model,
      isMobileDevice: this.localDataStorage.getSessionStorage().getItem("MobileTracking") == "MobileTrackingDevice"
    }
    return this.httpService.post<any, null>("swprocess/postCjResponseSw", { CJReqStr: JSON.stringify(request) });
  }

  isRiskAlter(model: ContractType): Observable<boolean> {
    return this.httpService.post<any, null>("swprocess/alteredriskstatusexcludingphone", { CJReqStr: JSON.stringify(model) });
  }
}
